export const formatMoney = (value: number | string | undefined | null, currency = "MWK") =>
  `${currency} ${Number(value || 0).toLocaleString()}`;

export const formatDateTime = (value?: string | Date | null) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString();
};
